/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

const EMPTY = { itemsTotal: 0, tax: 0, subtotal: null, total: 0, taxes: [], currency: null };

export const computeItemsBreakdown = (items, { priceIncludesTax } = {}) => {
  const safeItems = (items ?? []).filter(Boolean);
  if (!safeItems.length) return EMPTY;

  const taxBuckets = new Map();
  let taxCents = 0;
  let itemsTotal = 0;

  for (const item of safeItems) {
    const qty = item.qty ?? 1;
    const base = item.price * qty;
    itemsTotal += base;

    if (!item.tax) continue;

    const cents = priceIncludesTax
      ? (base * item.tax.ratio * 100) / (1 + item.tax.ratio)
      : base * item.tax.ratio * 100;

    if (cents <= 0) continue;
    taxCents += cents;

    const { id, name } = item.tax;
    const bucket = taxBuckets.get(id) ?? { id, name, amountCents: 0 };
    bucket.amountCents += cents;
    taxBuckets.set(id, bucket);
  }

  const tax = +(taxCents / 100);
  const subtotal = tax > 0
    ? priceIncludesTax ? itemsTotal - tax : itemsTotal
    : null;
  const total = priceIncludesTax ? itemsTotal : itemsTotal + tax;

  const taxes = Array.from(taxBuckets.values())
    .map(({ id, name, amountCents }) => ({ id, name, amount: +(amountCents / 100) }))
    .filter((t) => t.amount > 0);

  return {
    itemsTotal,
    tax,
    subtotal,
    total,
    taxes,
    currency: safeItems.find((i) => i.currency)?.currency ?? null,
  };
};
